import WaveformDetails from '@/resources/waveform-details';

export default {
  fetchData({ commit }, { waveformId }) {
    commit('startLoading');

    return WaveformDetails.fetch({ 'waveform-id': waveformId }).then(
      response => {
        commit('parseResponseData', response.data);
        commit('updateState');
      },
      () => {
        commit('setResponseError');
      }
    );
  },
  patch({ commit }, { waveformId, details }) {
    return WaveformDetails.patch({ 'waveform-id': waveformId }, details).then(
      response => {
        commit('parseResponseData', response.data);
        commit('updateState');
      },
      () => {
        commit('setResponseError');
      }
    );
  }
};
